import { Button, Modal, Row } from "react-bootstrap";
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { MySelect } from "../../ui/controls/MySelect";
import { MyTextInput } from "../../ui/controls/MyTextInput";
import { onlyIntegers, onlyIntegersDecimals } from "../../../helpers/numericFields";
import { useSelector, useDispatch } from 'react-redux';
import { addLodgingGroupRoomCategory, addRoomLodgingGroup } from "../../../store/slices/groupFiles/thunks";
import { MyTextInput66 } from "../../ui/controls/MyTextInput66";
import { getRoomCategoryList } from "../../../store/slices/catalogue/thunks";
import { useEffect, useState } from "react";
import { setRoomCategoryList } from "../../../store/slices/catalogue/catalogueSlice";
import { MyDatePicker } from "../../ui/controls/MyDatePicker";
import moment from "moment";
import { MyTextLabel } from "../../ui/controls/MyTextLabel";
import { addQuoteType2 } from "../../../store/slices/quotes/thunks";
import { MyTextLabel66 } from "../../ui/controls/MyTextLabel66";
import { currentDate } from "../../../helpers/dates";

export const AddQuote = ({groupFile, isOpen, setIsOpen }) => {
  const dispatch = useDispatch();
  const { hotelsList } = useSelector((state) => state.general);  
  const [daysNights, setDaysNights] = useState({days: '', nights: ''});

  useEffect(() => {
    dispatch(setRoomCategoryList([]))
  
      return () => {
        dispatch(setRoomCategoryList([]))
      }
    }, [])

  return (
    <>
      <Modal
        size="xl"
        show={isOpen}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header>
          <Modal.Title >
            Crear Cotizacion
          </Modal.Title>
          <Button
            onClick={() => setIsOpen(false)}
            className="btn-close"
            variant=""
          >
            x
          </Button>
        </Modal.Header>

        <Formik
          initialValues={{
            id: Date.now(),
            quoteDate: currentDate(),
            hotel: undefined,
            checkInCheckOutDate: undefined,
            paydayLimit: undefined,
            costPerNightSingle: '',
            costPerNightDouble: '',
            costPerNightTriple: '',
            costPerNightMinor: '',
            dateReservationFee: '',
            advancePaymentAdult: '',
            advancePaymentMinor: '',
          }}
          onSubmit={(({ id, quoteDate, hotel, checkInCheckOutDate, paydayLimit, costPerNightSingle, costPerNightDouble, costPerNightTriple, costPerNightMinor, 
            dateReservationFee, advancePaymentAdult, advancePaymentMinor
           }, { resetForm, setErrors }) => {                                  
            if (!hotel) {
              return setErrors({ "hotel": "Requerido" })
            }

            if(!quoteDate) {
              return setErrors({ "quoteDate": "Requerido" })
            }

            if (!checkInCheckOutDate || checkInCheckOutDate.length !== 2) {
              return setErrors({ "checkInCheckOutDate": "Requerido" })
            }

            if(!paydayLimit) {
              return setErrors({ "paydayLimit": "Requerido" })
            }

            let checkInDate;
            if (checkInCheckOutDate[0].year) {
              checkInDate = checkInCheckOutDate[0].year + "-" + (checkInCheckOutDate[0].monthIndex + 1) + "-" + checkInCheckOutDate[0].day
            } else {
              const temp = checkInCheckOutDate[0].split("-")
              checkInDate = temp[2] + "-" + temp[1] + "-" + temp[0]
            }
            let checkOutDate;
            if (checkInCheckOutDate[1].year) {
              checkOutDate = checkInCheckOutDate[1].year + "-" + (checkInCheckOutDate[1].monthIndex + 1) + "-" + checkInCheckOutDate[1].day
            } else {
              const temp = checkInCheckOutDate[1].split("-")
              checkOutDate = temp[2] + "-" + temp[1] + "-" + temp[0]
            }

            let paydayLimitDate;
            if (paydayLimit.year) {
              paydayLimitDate = paydayLimit.year + "-" + (paydayLimit.monthIndex + 1) + "-" + paydayLimit.day
            } else {
              const temp = paydayLimit.split("-")
              paydayLimitDate = temp[2] + "-" + temp[1] + "-" + temp[0]
            }

            const success = () => {
              resetForm();
              setIsOpen(false)
            }

            dispatch(addQuoteType2(id, quoteDate, hotel.value, checkInDate, checkOutDate, paydayLimitDate, costPerNightSingle, costPerNightDouble, costPerNightTriple,
              costPerNightMinor, dateReservationFee, advancePaymentAdult, advancePaymentMinor, success));
          })}
          validationSchema={
            Yup.object({              
              costPerNightSingle: Yup.number().required("Requerido"),
              costPerNightDouble: Yup.number().required("Requerido"),
              costPerNightTriple: Yup.number().required("Requerido"),
              costPerNightMinor: Yup.number().required("Requerido"),
              dateReservationFee: Yup.number().required("Requerido"),
              advancePaymentAdult: Yup.number().required("Requerido"),
              advancePaymentMinor: Yup.number().required("Requerido"),
            })
          }
        >

          {
            ({ setFieldValue }) => (
              <Form>
                <Modal.Body>
                  <Row>
                    <div className="col-lg-6 col-md-12">
                      <div className=" row mb-4">
                        <MySelect label='Hotel:*' name="hotel" options={hotelsList} mode='horizontal'
                          singleSelect="true"
                          onChange={e => {
                            setFieldValue("hotel", e);
                          }} />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                      <div className=" row mb-4">
                        <MyDatePicker
                          label='Entrada y Salida:*' name="checkInCheckOutDate" mode='horizontal'
                          className="form-control fc-datepicker"
                          singleSelect="true"
                          placeholder="dd/mm/aaaa ~ dd/mm/aaaa"
                          range
                          onChange={e => {
                            setFieldValue("checkInCheckOutDate", e);
                            if (!e || e.length === 2) {
                              const date1 = new moment(e[0].day + "-" + (e[0].monthIndex + 1) + "-" + e[0].year, "DD-MM-YYYY")
                              const date2 = new moment(e[1].day + "-" + (e[1].monthIndex + 1) + "-" + e[1].year, "DD-MM-YYYY")
                              setDaysNights({ days: date2.diff(date1, 'days') + 1, nights: date2.diff(date1, 'days') })
                            }
                          }} />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-12">
                      <div className=" row mb-4">
                        <MyTextLabel66 label='Noches:' mode='horizontal' value={daysNights.nights} />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-12">
                      <div className=" row mb-4">
                        <MyTextLabel66 label='Dias:' mode='horizontal' value={daysNights.days} />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                      <div className=" row mb-4">
                        <MyDatePicker
                          label='Fecha limite de pago:' name="paydayLimit" mode='horizontal'
                          className="form-control fc-datepicker"
                          singleSelect="true"
                          placeholder="dd/mm/aaaa"
                          onChange={e => {
                            setFieldValue("paydayLimit", e);
                          }} />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-12">
                      <div className=" row mb-4">
                        <MyTextInput66 label='$ Hab. Sencilla x Noche:*' name='costPerNightSingle' mode='horizontal'
                          onChange={(e) => {
                            if (!onlyIntegersDecimals(e)) {
                              return
                            }
                            setFieldValue("costPerNightSingle", e.target.value);
                          }} />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-12">
                      <div className=" row mb-4">
                        <MyTextInput66 label='$ Hab. Doble x Noche:*' name='costPerNightDouble' mode='horizontal'
                          onChange={(e) => {
                            if (!onlyIntegersDecimals(e)) {
                              return
                            }
                            setFieldValue("costPerNightDouble", e.target.value);
                          }} />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-12">
                      <div className=" row mb-4">
                        <MyTextInput66 label='$ Hab. Triple x Noche:*' name='costPerNightTriple' mode='horizontal'
                          onChange={(e) => {
                            if (!onlyIntegersDecimals(e)) {
                              return
                            }
                            setFieldValue("costPerNightTriple", e.target.value);
                          }} />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-12">
                      <div className=" row mb-4">
                        <MyTextInput66 label='$ Hab. Menor 3-12:*' name='costPerNightMinor' mode='horizontal'
                          onChange={(e) => {
                            if (!onlyIntegersDecimals(e)) {
                              return
                            }
                            setFieldValue("costPerNightMinor", e.target.value);
                          }} />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-12">
                      <div className=" row mb-4">
                        <MyTextInput66 label='$ Apartado de fecha:*' name='dateReservationFee' mode='horizontal'
                          onChange={(e) => {
                            if (!onlyIntegersDecimals(e)) {
                              return
                            }
                            setFieldValue("dateReservationFee", e.target.value);
                          }} />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-12">
                      <div className=" row mb-4">
                        <MyTextInput66 label='$ Anticipo adulto:*' name='advancePaymentAdult' mode='horizontal'
                          onChange={(e) => {
                            if (!onlyIntegersDecimals(e)) {
                              return
                            }
                            setFieldValue("advancePaymentAdult", e.target.value);
                          }} />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-12">
                      <div className=" row mb-4">
                        <MyTextInput66 label='$ Anticipo menor:*' name='advancePaymentMinor' mode='horizontal'
                          onChange={(e) => {
                            if (!onlyIntegersDecimals(e)) {
                              return
                            }
                            setFieldValue("advancePaymentMinor", e.target.value);
                          }} />
                      </div>
                    </div>
                  </Row>
                  
                  <div style={{ fontSize: 13 }}>* Dato obligatorio</div>
                </Modal.Body>

                <Modal.Footer>
                  <Button variant="primary" type="submit">
                    Guardar Informacion
                  </Button>
                </Modal.Footer>
              </Form>
            )
          }
        </Formik>


      </Modal>
    </>
  )
}
